module.exports = __webpack_public_path__ + "static/compose-slide-f1493e877ed7318711a8210ed416255e.png";